var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-card',{staticClass:"z-depth-2"},[_c('div',{staticClass:"px-6 pb-6"},[_c('groups-data-table',{attrs:{"hide-select":""}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }